import styled from "styled-components";

export const AlertBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff3e0;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #5d3e00;

  svg {
    color: #f59100;
    font-size: 18px;
    flex-shrink: 0;
  }
`;


export const InfoRow = styled.div`
  display: flex;
  gap: 32px;
  background: ${({ theme }) => theme.colors.neutral.neutral05};
  padding: 14px 20px;
  border-radius: 8px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  small {
    font-size: 14px;
    color: #555;
    font-weight: 400;
  }

  strong {
    font-size: 14px;
    color: #333;
    font-weight: 600;
  }
`;

export const Pergunta = styled.p`
  margin-top: 20px;
  font-size: 15px;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 8px;
`;

export const SucessoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  padding: 24px 16px;

  svg {
    background-color: #e5fff8;
    color: #10ac85;
    border-radius: 10px;
    padding: 8px;
    font-size: 30px;
  }

  span {
    font-size: 15px;
    color: #333;
    max-width: 320px;
  }
`;
